module.exports = __webpack_public_path__ + "static/img/banner.f3c5d161.png";